// extracted by mini-css-extract-plugin
module.exports = {"banner":"Cards_banner__2-XSG","redirectCta":"Cards_redirectCta__A0R5_"};